import * as React from "react";
import { WidgetWrapper } from "uxp/components";
import { IUIPropertyDefinitionMap, IWidgetTemplateProps, registerCardTemplate } from "../../../common/common";
import { generateIconProp } from "../../../common/icon-selector/IconEditor";
import { SelectableItem, selectUIProps } from "../../../common/SelectableItem";
import { SimpleTextProperty } from "../../../common/ui-props/SimpleTextProperty";
import MapsIndoorsComponent from "./MapsIndoorComponent";
import { IContextData, useInitialContextData } from "../../../../hooks/useContextData";
import { replaceWithData } from "../../../../util";

const XPR: React.FunctionComponent<IWidgetTemplateProps> = props => {

    let uiProps = props?.uiProps || {};
    console.log(uiProps);

    const XPRProps: IUIPropertyDefinitionMap = {
        'MapsIndoorAPIKey': SimpleTextProperty('MapsIndoor API Key', '', true),
        'InitialCenterLatitude': SimpleTextProperty('Initial Centerl Latitude', '', true),
        'InitialCenterLongitude': SimpleTextProperty('Initial Center Longitude', '', true),
        'Zoom': SimpleTextProperty('Zoom', '', true),
    }

    const [loading, setLoading] = React.useState(false)
    let [contextData, setContextData] = React.useState<IContextData>({})

    const { isLoading, initialContextData } = useInitialContextData(props)

    React.useEffect(() => {
        setLoading(isLoading)
        setContextData(prev => ({ ...prev, ...initialContextData }))
    }, [isLoading, initialContextData])

    return <WidgetWrapper >

        <SelectableItem
            designer={props.designer}
            props={selectUIProps(uiProps, XPRProps, 'MapsIndoorAPIKey', 'InitialCenterLatitude', 'InitialCenterLongitude', 'Zoom')}
            contextData={contextData}
        >
            <MapsIndoorsComponent
                mapsIndoorsKey={replaceWithData(uiProps.MapsIndoorAPIKey, contextData)}
                initialCenterLatitude={replaceWithData(uiProps.InitialCenterLatitude, contextData)}
                initialCenterLongitude={replaceWithData(uiProps.InitialCenterLongitude, contextData)}
                zoom={replaceWithData(uiProps.Zoom, contextData)}
            ></MapsIndoorsComponent>
        </SelectableItem>

    </WidgetWrapper>
}


registerCardTemplate({
    id: 'mapsindoor',
    name: "MapsIndoors",
    description: 'A widget to show MapsIndoors and get directions',
    template: XPR,
    icon: generateIconProp('map'),
    complexity: 'medium',
});